/**
 * Pagination
 */

// Module dependencies
import 'protons';

// Module template
import './_pagination.twig';
import './_pagination.css';

export const name = 'pagination';
export function disable() {}
export function enable() {}
export default enable;
